import { __ } from '@wordpress/i18n';

export default function save() {
	return null;
}